import { arrayOf, objectOf } from "@altostra/type-validations";
import { number } from "@altostra/type-validations/lib/primitives";

import {
  isCreativeVariantAction,
  isCreativeVariantWarning,
} from "../decisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensionsDimension";
import type {
  DeleteDecisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensionsDimensionActionsActionIdResult,
  PutDecisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensionsDimensionActionsActionIdResult,
} from "./types";

export const isPutDecisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensionsDimensionActionsActionIdResult =
  objectOf<PutDecisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensionsDimensionActionsActionIdResult>({
    action: (
      v: unknown
    ): v is PutDecisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensionsDimensionActionsActionIdResult["action"] => {
      if (!isCreativeVariantAction(v)) {
        return false;
      }
      const replacementActionId = (v as { replacementActionId?: unknown }).replacementActionId;
      return replacementActionId === undefined || typeof replacementActionId === "number";
    },
    warnings: arrayOf(isCreativeVariantWarning),
  });

export const isDeleteDecisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensionsDimensionActionsActionIdResult =
  objectOf<DeleteDecisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensionsDimensionActionsActionIdResult>({
    deletedActionId: number,
  });
